<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HDIdrH/tc-custom/9781504010146.jpg?1726519331311" alt="This image is the cover for the book Louisiana Purchase"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Louisiana Purchase
      </h1>
      <p class="bookDescription body article font2">
        <b>The big purchase that led to fundamental questions about what America would become</b><br/><br/> In 1803 President Thomas Jefferson bought the Louisiana Territory from the French for $15 million, extending the United States beyond the Mississippi River for the first time.<br/>  <br/> Now the United States had big questions to answer: How would Louisiana be governed? How would it be divided? Would it be comprised of free states or slave states? What would happen to the Native Americans? With biographical sketches of the people who helped forge the answers to these questions, such as Lewis and Clark, Napoleon Bonaparte, and of course, Thomas Jefferson, this is the tale of the expansion of the United States into a new territory as well as a new era.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Roop, Connie Roop
      </h2>
      
      <p class="authorDescription body article">Peter and Connie Roop are award-winning authors and educators who have published over one hundred children&rsquo;s books, including the Reading Rainbow feature selection <I>Keep the Lights Burning, Abbie</I>.&#160;They have written biographies, historical fiction, general fiction, and science books. In 2013 the Wisconsin Library Association recognized the Roops as Notable Wisconsin Authors for their body of work, and&#160;Peter Roop has been named a Wisconsin State Teacher of the Year.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d8359ed